if (document.querySelector('.iww-three-points')) {

// BEI KLICK AUF THREE POINTS

    // Get all matching .iww-three-points elements
    const items = document.querySelectorAll('.iww-three-points');

// Iterate over the NodeList of elements to add the click event listener
    items.forEach(item => {
        item.addEventListener('click', function (event) {

            let ariaHidden = this.getAttribute('aria-hidden');

            if (ariaHidden === 'true') {
                this.setAttribute('aria-hidden', 'false');
            } else {
                this.setAttribute('aria-hidden', 'true');
            }
        });


    });

    document.body.addEventListener('click', function (e) {
        var target = e.target;

        items.forEach(item => {
            if (!target.closest('.iww-three-points') && (item.getAttribute('aria-hidden') === 'true')) {
                item.setAttribute('aria-hidden', 'false');
            }
        });
    });
}
